import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import { kstheme } from "../../theme/theme";

const customStyle = makeStyles({
  ContentBody: {
    fontFamily: "DMSans",
    fontSize: "20px",
    color: "#000000",
    opacity: 0.8,
    textAlign: "justify",
  },

});

function Security() {

  const isMobile = useMediaQuery(kstheme.breakpoints.down("sm"));
  const classes = customStyle();
  return (
    <>
      <Box pt={4} id={"security"} style={{ backgroundColor: '#fff' }}>
        <Container maxWidth="xxl">
          <Grid container minHeight="50vh">
            <Grid item xs={12} md={12} px={{ xs: isMobile ? 1 : 9 }} mb={6}>
              <Typography variant="h2" color={"#31B9B5"} my={5} fontWeight={700} fontSize="32px">
                Security
              </Typography>
              <Box>
                <Typography mb={2} className={classes.ContentBody} fontWeight={500}>
                  {`Our obligations to customers do not stop at just providing
                    financial solutions. We care about our customer's trust .We
                    take the data & payment security with utmost seriousness. The
                    below speak for themselves`}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Security;
